import { APP_NAME } from '../utils/environment';
import AbstractModule from './AbstractModule';

const MODULE_NAME = 'Slider';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const EVENT = {
    CLICK: `click.${EVENT_NAMESPACE}`
};

const CLASS = {
    ACTIVE: 'is-active',
    ACTIVE_END: 'is-active-end',
}

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        // Declaration of properties
        this.$sliders = $('.js-slider', this.$el);
        this.length = $('.js-slide', this.$el).length;
        this.$background = $('.js-background', this.$el);
        this.stop = false;
    }

    init() {
        // Set events and such

        this.idx = 0;
        // this.changeSlide();
        setTimeout(() => {
            this.changeSlide();

            setInterval(() => {
                if(!this.stop) {
                    this.changeSlide();
                }
            },5000);
        },100);

        this.animate();

    }

    animate() {
        this.raf = requestAnimationFrame(()=>this.animate());

        if(!this.stop && window.scroll.y > window.innerHeight / 3) {
            this.stop = true;
        }

        if(this.stop && window.scroll.y < window.innerHeight / 3) {
            this.stop = false;
        }
        let opacity = ((window.scroll.y / (window.scroll.limit - window.innerHeight)) * 0.9) > 0.9 ? 0.9 : (window.scroll.y / (window.scroll.limit - window.innerHeight)) * 0.9
        this.$background.css({
            'opacity': opacity
        })
    }

    changeSlide() {
        for (var i = this.$sliders.length - 1; i >= 0; i--) {
            let $slider = $(this.$sliders[i])
            let $slides = $('.js-slide', $slider);

            $slides.filter(`.${CLASS.ACTIVE}`).addClass(CLASS.ACTIVE_END).removeClass(CLASS.ACTIVE);
            $slides.eq(this.idx).addClass(CLASS.ACTIVE);

            setTimeout(() => {
                $slides.filter(`.${CLASS.ACTIVE_END}`).removeClass(CLASS.ACTIVE_END);
            },600);
        }

        if(this.idx < this.length - 1) {
            this.idx++;
        } else {
            this.idx = 0;
        }
    }

    destroy() {
        cancelAnimationFrame(this.raf);

        super.destroy();
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}
